export const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

export const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 19,
    },
    sm: {
      span: 24,
      offset: 19,
    },
  },
};



// WEBPACK FOOTER //
// src/constants/tableLayout.js